export const selectWrapper = {
    select: {
        '+ svg': {transform: 'translateY(-50%) translateY(2px)'},
        'marginBottom': 0,
    },
}

export const error = {color: '$inputErrorMessage'}
